const normSerial = (s) => (s == null ? '' : String(s).trim().toUpperCase())

/**
 * 直播 ezopen 地址（与现有业务页一致：open.ys7.com）
 * @param {string} deviceSerial
 * @param {number} [channelNo=1]
 */
export function buildLiveEzopenUrl (deviceSerial, channelNo = 1) {
  const serial = normSerial(deviceSerial)
  if (!serial) return ''
  const ch = Number(channelNo) >= 1 ? Number(channelNo) : 1
  return `ezopen://open.ys7.com/${serial}/${ch}.live`
}
